import api from '../api/api';

export function AddToBasket(productId, quantity) {
  const addToBasketUrl = `/web/services/shoppingBasket/lineItems/${productId}/${quantity}`;

  return api.put(addToBasketUrl, null)
    .catch(exception => {
      const error = exception;
      error.statusText = `Call to AddToBasketUrl with ${addToBasketUrl} failed. ${exception.statusText}`;
      return Promise.reject(error);
    });
}



// WEBPACK FOOTER //
// ./src/main/ui/react/shared/services/Basket/Basket.js